import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  GET_SURVEYTEMPLATE,
  DELETE_SURVEYTEMPLATE,
  UPDATE_SURVEYTEMPLATE,
  ADD_NEW_SURVEYTEMPLATE,
} from "./actionType";

import {
  getSurveyTemplateSuccess,
  getSurveyTemplateFail,
  deleteSurveyTemplateSuccess,
  deleteSurveyTemplateFail,
  updateSurveyTemplateSuccess,
  updateSurveyTemplateFail,
  addSurveyTemplateSuccess,
  addSurveyTemplateFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveSurveyTemplateApi,
  getSurveyTemplateApi,
  updateSurveyTemplateApi,
  deleteSurveyTemplateApi,
  addNewSurveyTemplateApi,
} from "../../helpers/backend_helper";

function* getSurveyTemplate({ payload: surveyTemplate }) {
  try {
    const response = yield call(getSurveyTemplateApi, surveyTemplate);
    yield put(getSurveyTemplateSuccess(GET_SURVEYTEMPLATE, response.data));
  } catch (error) {
    yield put(getSurveyTemplateFail(GET_SURVEYTEMPLATE, error));
  }
}

function* onUpdateSurveyTemplate({ payload: surveyTemplate }) {
  try {
    if (surveyTemplate.setApprove) {
      const response = yield call(approveSurveyTemplateApi, surveyTemplate);
      yield put(updateSurveyTemplateSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    } else {
      const response = yield call(updateSurveyTemplateApi, surveyTemplate);
      yield put(updateSurveyTemplateSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateSurveyTemplateFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteSurveyTemplate({ payload: surveyTemplate }) {
  try {
    const response = yield call(deleteSurveyTemplateApi, surveyTemplate);
    yield put(deleteSurveyTemplateSuccess({ surveyTemplate, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteSurveyTemplateFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewSurveyTemplate({ payload: surveyTemplate }) {
  try {
    const response = yield call(addNewSurveyTemplateApi, surveyTemplate);
    yield put(addSurveyTemplateSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addSurveyTemplateFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

export function* watchGetSurveyTemplate() {
  yield takeEvery(GET_SURVEYTEMPLATE, getSurveyTemplate);
}

export function* watchUpdateSurveyTemplate() {
  yield takeEvery(UPDATE_SURVEYTEMPLATE, onUpdateSurveyTemplate);
}

export function* watchDeleteSurveyTemplate() {
  yield takeEvery(DELETE_SURVEYTEMPLATE, onDeleteSurveyTemplate);
}

export function* watchAddNewSurveyTemplate() {
  yield takeEvery(ADD_NEW_SURVEYTEMPLATE, onAddNewSurveyTemplate);
}

function* surveyTemplateSaga() {
  yield all([
    fork(watchGetSurveyTemplate),
    fork(watchDeleteSurveyTemplate),
    fork(watchUpdateSurveyTemplate),
    fork(watchAddNewSurveyTemplate),
  ]);
}

export default surveyTemplateSaga;
